export const toggleVisibilityOfExpandLinkOnResize = (showMoreColorsLink: HTMLElement) => {
    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            if (entry.contentRect.width >= 768) {
                showMoreColorsLink.classList.remove('pl_hidden');
            } else {
                showMoreColorsLink.classList.add('pl_hidden');
            }
        });
    });
    resizeObserver.observe(document.body);
};
